import classNames from "classnames";

import useBlueprintContext from "../context/useBlueprintContext";
import { ScraperVersion } from "../../scraper/types";
import StepCard from "../../shared/StepCard";
import { Chrome } from "lucide-react";
interface Props {
  scraper: ScraperVersion;
}

const BlueprintScraperCard = ({ scraper }: Props) => {
  const { selectedStep, setSelectedStep } = useBlueprintContext();

  const isHighlighted = selectedStep === scraper;

  const cardClass = classNames(
    isHighlighted ? "step-card-highlighted" : "step-card-not-highlighted"
  );

  return (
    <StepCard
      cardClassName={cardClass}
      title="Scraper"
      subtitle={scraper.name}
      icon={<Chrome />}
      onClick={() => setSelectedStep(scraper)}
    />
  );
};

export default BlueprintScraperCard;
